export const DISMISS_STATE_KIND = {
	SEEN: 'SEEN',
	TIMER_RUNNING: 'TIMER_RUNNING',
	DISMISSED: 'DISMISSED',
} as const;
